<template>
  <label class="pat-badge" :class="{ 'pat-badge--checked': showCheckbox && checked }">
    <input
      v-if="showCheckbox"
      type="checkbox"
      class="pat-badge-checkbox"
      :checked="checked"
      @change="$emit('change', $event.target.checked)"
    />
    {{ barCode }}
  </label>
</template>

<script>
export default {
  name: "PatrimonyBadge",
  props: {
    barCode: { type: String, required: true },
    showCheckbox: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
  },
  emits: ["change"],
};
</script>

<style scoped>
.pat-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e0e7ff;
  color: #4338ca;
  padding: 13px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 400;
  margin: 3px;
  line-height: 1;
}

.pat-badge[class*="--checked"],
.pat-badge--checked {
  background: #e0e7ff;
  color: #4338ca;
}

.pat-badge-icon {
  font-size: 11px;
  opacity: 0.7;
}

.pat-badge-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  align-self: center;
  transition: background 0.2s;
  margin: 0;
}

.pat-badge-checkbox:checked {
  background: #ffffff;
}

.pat-badge-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: #111827;
  line-height: 1;
}
</style>

<style>
.dark-theme .pat-badge,
.dark-theme .pat-badge--checked {
  background: #e0e7ff !important;
  color: #4338ca !important;
  border-color: #c7d2fe !important;
}

.dark-theme .pat-badge-checkbox {
  background: rgba(255, 255, 255, 0.55) !important;
}

.dark-theme .pat-badge-checkbox:checked {
  background: #ffffff !important;
  border-color: transparent !important;
}
</style>
